import { useLogin } from './useLogin';
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useUser } from '@/components/AuthInterceptorComponent/hooks/useUser';
import { QueryKeys } from '@/constants/queryKeys';
import { CONFIG_STALE_TIME, fetchConfig } from '@/hooks/useConfig';

export const useInterceptor = () => {
  //  login
  const login = useLogin();
  const user = useUser();
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!login.isLoading && login.isSuccess) {
      user.refetch();
      // The config only needs what login just stored (token + original_company_id),
      // so request it alongside the user instead of waiting for PersonalizedTheme
      // to mount once the user resolves.
      queryClient.prefetchQuery({
        queryKey: [QueryKeys.CONFIG],
        queryFn: fetchConfig,
        staleTime: CONFIG_STALE_TIME,
      });
    }
  }, [login.isSuccess, login.isLoading, user.refetch]);

  // request info user
  const enableRender = user.isSuccess && user?.data?.pk;
  return {
    enableRender,
  };
};
